import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
// TODO: Add react-helmet-async when React 19 support is available for SEO meta tags

import "../pages/header.css";
import "../pages/Uploads.css";

import logotypeDark from "../assets/dance_locale_3-200h.png";
import danceLocaleIcon from "../assets/logo_fox_map_pin_v4-600h.png";
import apiClient from "../api/client";

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState(""); // "success" or "error"
    const [isValidToken, setIsValidToken] = useState(true);

    useEffect(() => {
        // Check if token exists
        if (!token || token === "reset-password") {
            setMessage("Invalid or missing reset token. Please request a new password reset.");
            setMessageType("error");
            setIsValidToken(false);
        }
    }, [token]);

    const handleSubmit = async e => {
        e.preventDefault();

        // Validate passwords match
        if (newPassword !== confirmPassword) {
            setMessage("Passwords do not match. Please try again.");
            setMessageType("error");
            return;
        }

        // Validate password length
        if (newPassword.length < 5) {
            setMessage("Password must be at least 5 characters long.");
            setMessageType("error");
            return;
        }

        setIsLoading(true);
        setMessage("");

        try {
            // Shared client: adds the X-App-Version dev header on localhost/devMode and
            // returns { ok, data } already flattened (never throws on HTTP error).
            const response = await apiClient.post("/api/v2/auth/reset-password", { token, newPassword });

            if (response.ok && response.data?.success) {
                setMessage("Password reset successfully! You can now log in with your new password.");
                setMessageType("success");

                // Redirect after 3 seconds
                setTimeout(() => {
                    navigate("/login");
                }, 3000);
            } else {
                setMessage(response.data?.message || "Password reset failed. Please try again or request a new reset link.");
                setMessageType("error");
            }
        } catch (error) {
            console.error("Reset error:", error);
            setMessage("An error occurred. Please try again later.");
            setMessageType("error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="dashboard-container branded-bg">
                        {/* TODO: Add SEO meta tags when react-helmet-async supports React 19
                Title: "Reset Password - Dance Locale" */}

            {/* Header */}
            <div data-role="Header" className="home-header-container">
                <header className="home-header">
                    <a href="/" className="home-logo1">
                        <img alt="Dance Locale" src={logotypeDark} className="home-image1" />
                        <span className="nav-wordmark">Dance Localé</span>
                    </a>
                    <div className="home-menu1">
                        <a href="/" className="home-text10" style={{ cursor: "pointer", textDecoration: "none" }}>
                            Home
                        </a>
                        <a href="/faq" className="home-text11" style={{ cursor: "pointer", textDecoration: "none" }}>
                            FAQ
                        </a>
                    </div>
                </header>
            </div>

            {/* Main Content */}
            <div className="dashboard-main">
                <div className="dashboard-content-wrapper" style={{ maxWidth: "500px" }}>
                    <div className="dashboard-header-card">
                        <div style={{ textAlign: "center", marginBottom: "var(--dl-layout-space-unit)" }}>
                            <img
                                src={danceLocaleIcon}
                                alt="Dance Locale"
                                style={{ width: "60px", height: "60px", marginBottom: "var(--dl-layout-space-unit)" }}
                            />
                        </div>

                        <h1 className="admin-console-title">Reset Your Password</h1>
                        <p className="admin-console-description">
                            Enter your new password below. Make sure it's at least 5 characters long and something
                            you'll remember.
                        </p>

                        {message && <div className={`admin-console-status ${messageType}`}>{message}</div>}

                        {isValidToken && (
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label className="form-label" htmlFor="newPassword">
                                        New Password
                                    </label>
                                    <input
                                        type="password"
                                        id="newPassword"
                                        name="newPassword"
                                        autoComplete="new-password"
                                        value={newPassword}
                                        onChange={e => setNewPassword(e.target.value)}
                                        className="form-input"
                                        placeholder="Enter your new password"
                                        required
                                        minLength="5"
                                        /* 16px is deliberate: below 16px iOS Safari auto-zooms on focus */
                                        style={{ fontSize: "16px" }}
                                    />
                                </div>

                                <div className="form-group">
                                    <label className="form-label" htmlFor="confirmPassword">
                                        Confirm New Password
                                    </label>
                                    <input
                                        type="password"
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        autoComplete="new-password"
                                        value={confirmPassword}
                                        onChange={e => setConfirmPassword(e.target.value)}
                                        className="form-input"
                                        placeholder="Confirm your new password"
                                        required
                                        minLength="5"
                                        /* 16px is deliberate: below 16px iOS Safari auto-zooms on focus */
                                        style={{ fontSize: "16px" }}
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="btn-purple btn-large"
                                    disabled={isLoading || !isValidToken}
                                    style={{ width: "100%" }}>
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "8px",
                                        }}>
                                        {isLoading && <span className="admin-console-spinner"></span>}
                                        {isLoading ? "Resetting..." : "Reset Password"}
                                    </span>
                                </button>
                            </form>
                        )}

                        <div style={{ textAlign: "center", marginTop: "var(--dl-layout-space-unit)" }}>
                            <a
                                href="/"
                                style={{
                                    color: "var(--dl-color-purple-default)",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                }}>
                                ← Back to Dance Locale
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
